import { ready } from '~/core'

/**
 * Note: all props passed to `.impact-highlight__content-title` via data-{prop name here}
 * @param {integer} value - number amount to count up to
 * @param {string} type - type of `value` being passed, accepts 'number', 'money', 'percentage'
 */

ready('impact-highlight', '.impact-highlight', (root) => {
  const counterElements = [...root.querySelectorAll('.impact-highlight__content-title')]

  function setupCountAnimation(element) {
    const data = element && element.dataset

    //sanitize value to be a number
    const endValue = Number(data.value.replace(/\D+/g, ''))
    const valueType = (data.type || '').toLowerCase()

    let durationInMs = 150
    let incrementPercentage = 5

    //change it via querystring for testing
    //const urlParams = new URLSearchParams(window.location.search);
    //durationInMs = urlParams.get('duration')!=null?parseInt(urlParams.get('duration')) : durationInMs;
    //incrementPercentage = urlParams.get('percentage')!=null?parseInt(urlParams.get('percentage')) : incrementPercentage;

    let currentValue = 0
    let incrementValue = Math.round((incrementPercentage / 100) * endValue)

    const interval = setInterval(() => {
      currentValue += incrementValue

      if (currentValue >= endValue) currentValue = endValue

      switch (valueType) {
        case 'number':
          element.textContent = currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          break
        case 'money':
          element.textContent = `$${currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
          break
        case 'percentage':
          element.textContent = `${currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}%`
          break
        default:
          element.textContent = currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          break
      }

      if (currentValue >= endValue) clearInterval(interval)
    }, durationInMs)
  }

  const observerConfig = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  }

  const observer = new IntersectionObserver((entries) => {
    const thisSection = entries[0]

    if (!thisSection.isIntersecting) return

    counterElements.forEach((element) => setupCountAnimation(element))

    if (thisSection.isIntersecting) observer.unobserve(root)
  }, observerConfig)

  observer.observe(root)
})
